export const GrainOverlay = () => <div className="grain-overlay" aria-hidden="true" />;

export default GrainOverlay;
